<div class="main-container">
  <div class="cause-list" *ngIf="!isMobile">
    <div class="cause" *ngFor='let cause of causes'>
      <a *ngIf="!cause?.outer" [routerLink]="[cause?.link]" [queryParams]="cause?.params" queryParamsHandling="merge">
        <div class="cause-bg">
          <img class="{{cause?.class}} cause-img" loading="lazy" [src]="cause?.imgSrc">
          <div class="details">
            <span class="title">{{ cause?.title }}</span>
            <span class="desc">{{ cause?.desc }}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
  <!-- <div class="swiper-container" [swiper]="config" *ngIf="isMobile">
    <div class="swiper-wrapper cause-list">
        <ng-container *ngFor="let cause of causes; index as i">
          <div class="swiper-slide cause">
            <a *ngIf="!cause?.outer" [routerLink]="[cause?.link]" [queryParams]="cause?.params" queryParamsHandling="merge">
              <div class="cause-bg">
                <img class="{{cause?.class}} cause-img" loading="lazy" [src]="cause?.imgSrc">
                <div class="details">
                  <span class="title">{{ cause?.title }}</span>
                  <span class="desc">{{ cause?.desc }}</span>
                </div>
              </div>
            </a>
          </div>
        </ng-container>
    </div>
  </div> -->
  <div class="glide-container" *ngIf="isMobile">
      <ngx-glide [showArrows]="false" [showBullets]="false" [gap]="10" type="slider" [breakpoints]="breakpoints" [perView]="2.2"
            arrowLeftLabel="" arrowRightLabel="" [bound]="true">
            <div class="cause" *ngFor='let cause of causes'>
              <a *ngIf="!cause?.outer" [routerLink]="[cause?.link]" [queryParams]="cause?.params" queryParamsHandling="merge">
                <div class="cause-bg">
                  <img class="{{cause?.class}} cause-img" loading="lazy" [src]="cause?.imgSrc">
                  <div class="details">
                    <span class="title">{{ cause?.title }}</span>
                    <span class="desc">{{ cause?.desc }}</span>
                  </div>
                </div>
              </a>
            </div>
      </ngx-glide>
    </div>
</div>